import {getFormatText, getReverseDate} from "@/scripts/formatDate";

export class OrderLineParent {
  constructor() {
    this.list = []
  }

  addOrderLine(item) {
    this.list.push(OrderLine.buildFromAPI(item))
  }

  updateOrderLine(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, OrderLine.buildFromAPI(item))
  }

  removeOrderLine(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => OrderLine.buildFromAPI(el))
    }
    return this
  }
}

export class OrderLine {
  constructor() {
    this.id = null
    this.application = null
    this.order = null
    this.studentNumber = null
    this.group = null
    this.contractNumber = null
    this.contractDate = null
  }

  get contractDateText () {
    return this.contractDate && getFormatText(this.contractDate)
  }

  getForShortAPI() {
    return {
      id: this.id,
      application: { id: this.application.id },
      order: this.order,
      studentNumber: this.studentNumber,
      group: this.group,
      contractNumber: this.contractNumber,
      contractDate: getReverseDate(this.contractDate),
    }
  }

  getForAPI() {
    return {
      id: this.id,
      application: this.application,
      order: this.order,
      studentNumber: this.studentNumber,
      group: this.group,
      contractNumber: this.contractNumber,
      contractDate: this.contractDate,
    }
  }

  static buildFromAPI(obj) {
    const _this = new OrderLine()
    if (obj) {
      _this.id = obj.id
      _this.application = obj.application
      _this.order = obj.order
      _this.studentNumber = obj.studentNumber
      _this.group = obj.group
      _this.contractNumber = obj.contractNumber
      _this.contractDate = obj.contractDate
    }
    return _this
  }
}